/**
 * Lanificio footer (sections/lan-footer.liquid): de garenbol draait alleen
 * als hij in beeld is. De kolommen staan op elk scherm open.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Garenbol alleen laten draaien als hij in beeld is.
    var yarn = document.querySelector('.lan-footer .lan-yarn');
    if (yarn && 'IntersectionObserver' in window) {
      yarn.setAttribute('data-paused', '');
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) yarn.removeAttribute('data-paused');
          else yarn.setAttribute('data-paused', '');
        });
      }).observe(yarn);
    }
  });
})();
